const McIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="100%"
            height="100%"
            viewBox="0 0 70 80"
        >
            <defs />
            <g>
                <image
                    x="0"
                    y="0"
                    width="70"
                    height="80"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAADACAYAAACDO2h3AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9
    kT1Iw0AcxV9TRdGKgh2kOGSoThZERRy1CkWoEGqFVh1MLv2CJg1Jiouj4Fpw8GOx6uDirKuDqyAI
    foA4OzgpukiJ/0sKLWI8OO7Hu3uPu3eAUC8zzeoYBzTdNlOJuJjJropdrxAQQS8GEJSZZcxJUhK+
    4+seAb7exXiW/7k/R5+asxgQEIlnmWHaxBvE05u2wXmfOMyKskp8Tjxm0gWJH7muePzGueCywDPD
    Zjo1TxwmFgttrLQxK5oa8RRxVNV0yhcyHquctzhr5Spr3pO/MJTTV5a5TnMYCSxiCRJEKKiihDJs
    xGjVSbGQov24jz/i+iVyKeQqgZFjARVokF0/+B/87tbKT054SaE40PniOB8jQNcu0Kg5zvex4zRO
    gOAzcKW3/JU6MPNJeq2lRY+A/m3g4rqlKXvA5Q4w9GTIpuxKQZpCPg+8n9E3ZYHBW6BnzeutuY/T
    ByBNXSVvgINDYLRA2es+7+5u7+3fM83+fgAFhXJ7S2iSMgAAAAZiS0dEAGkAfACfUDqxogAAAAlw
    SFlzAAAPYQAAD2EBqD+naQAAAAd0SU1FB+gCGgstIoq4Iz4AAB0GSURBVHhe7Z13dBvHnce/INFZ
    QLCBJNiLRJESJVHFkqxiFUtyYluK47jEOlu+uyQvxb7LJe9yTs5+uSR3eZfk8l4uiWPnXs7lEjsu
    kuw4iSMrtkxVU5Vd7L2DJMAKgm3vj0Vb7A6KSAKL5XxsiNjZmcXO7Hd/M7/Z2RkZvPD2hRrG234K
    xV8e3LlWJhQuGEiFR1kuPIXIEyAVH2W5cRchR4BUfJRg4RChU4Bvna+m4qMElc/tWieTA8Cb56oY
    hqH6owQfGQC8ca6Kqo8SEmRvlFUGLD6GARiGAQPG9Z1hvwOu7+7hjEc4GAYMPOI4vsMjnkB6z+OC
    k174uBAK5+XBfiyh3/NID156Nh0vPSfM8buO9K5t7m+7pXP/HU6Yx7GIae3Hdj9/XpgrLeCx7fU8
    +WHfOP4A/EVuPwefREZGOE+eQvHGT146CQYMvnn8s76iIsJ+b3n9Ty6P9HUcCoXHj1864VNbEWAA
    bx+FXO7lJygU7/zkf0941ZfcW5WqVCqI+8SEDGx+KOLEm8YivBnAcCGcznUl8pOXTxI1JocEnApq
    AcMAgs7kpAunVikJe8QHFZ/4IV0jr21ACmWpIOnM735ACmUxkHQmpxUYJThQC0gJIUQLSNuAlGBA
    0lmEYCiFEiSoBaQEBbIXLBhMoSwtxH5AKTwJoYQBUu4HpI/ixA/ZC5bApQv/HEgfks7kUrh61AKG
    AVLuBwz/HEgfL15w+F8+agHFj6SrYAlkQfpI2QmhFlD8EC2gBJqAVHxhAHk4lhQUSBE/9FFcaEhP
    1kOjkqNrwIIpm81XdMlCfBQnhW4YsfLFo7tQkJEMABgencQLp8owZJn0kUqaEIdjMQxrHT0/4YTg
    NK8h5o7iHKf4ACBBF4V77yzxkkLakHQmiSH5YsxBgi6KF6ZRhceL/suDhL1g2g0jfuhgBEpIkfST
    kFBZwLV5aUhL1KG524SmrkFf0Vc2RAsogTo4FDk4srsEW9ZkAQB2byxA2c0mvH+p1keqlQvZCwZ7
    AT0/4USwvWB9rNYpPgd7NhascCfDOySdSeJJSLBzEB/D93ABwJgcF1BVnGHQQ6NSgnG0kBhgyDIB
    k2UcAKBVK5FliGe7LMDYLxWD9r5hTFrDrFNbyk9CQtUGXCz37VqP1ZkGTtgH5XV451wFACDLEI9/
    eHg/L91PXz+D2tZeXriYIV0f2gakBAXigFQpXL1wtYArCsIFov2ABPQxWmxclY6RsSlcr+/0FV10
    iO2mlPR4wKVmTXYKHrhrvXN70+oMvPjOBS8pxIfYLitJZxHEp8RhxFJ3w2xfl8PZTk3UoTgnlRCb
    4hcEnUmiH3Cpzzc1IZYflqgTiEnxF5LOJOEFi629Q+Ej6cmJpJAHqUO6RpJ4EkItYBhAfBYs3DYM
    K5b6dG+19/PC6tr6BGJS/IWkM+JiheHEUnvBH11vRN/wmHP7jxdr0Ds06iUFxRcknUniSchSZ8Ey
    bsVv3rsE5zq64VYliBFCEVIvmBIUqBe8whDbTRlmXnBgxRdYbPFQ0diFroER5yVgwKChY8C53zQ6
    gdOf1Nn3uOKYzBO8Y3kiuvIgW0DRnSoCLb7AYi8eq21GMLxn0CIYTuJSVQsYsNWT4697ZoYsEzhV
    dtO+394eBeNXhsV2U5J0JtLBCIEVX2Cx/WPHulzkpCagtXcI1+o7YZ12ia53aBQtPSbkGZOcYWU3
    m2C1zQodKiQsdXksFpLORFoFB3ZOgcX2zb5Nq5wDEnLSElCUncIbDfPSHz/B7g15UCsVGBmbQnlt
    m9ChKA7CywkJzKYFFts3QqNhco2JaOkZ4oSfu9nsrBop3iEVkUi7YQI7p8BiU0KBpIfkU8IAUhtQ
    nF5w+DM1zfeUxeSkBJsw84LFT1qSDrvX50OjUqDbZEHZjUZMTbsEVl7bhpJ8I9KT9QDYrpsPr9WT
    Did5yF4wtYABo1Ep8OSntztnQshLT4JGpcDJsxXOOFbbLH72xkcoyU9HfKwWlU3dGBr13YEsXagF
    XDKKc9N403BsLcrmCNBBZVO3353HUoZoAcXpBd8exdkpyDMmOLcdF/5EWZUzbNf6PBj00W5xgPqO
    Adxs7Ia/xMdofUWheCDpwQgOYqNUyEiO8xrHEB+DLIOeE9bvNvaPsjwQ+wFpLyolKBAtINXfsqFR
    KWFMigPA0GUaaD9gcNGoFHj6oX3OycqHRyfx09f/Ktg/uBIg6SwCDCD4oSyKvZtWc2bKT9BFYf/m
    1V5SSByCzkRqAQMbXhBY7ODAVr1cHJ3SK5EwexIS2EkFFpsSCsJsPGBgNi2w2JSQEF79gIGdVWCx
    KaGAdI0i2Hdf+R/K4hCarLwxgAnMpQZJZ9QLXibKa9s4ImzsHMTl6lYvKSROeHnB4Y/VNotfv3Me
    xiQ9GDDoHjC7PMEV2GgNMy9YOnQPmvmFvwLLnI4HFBMr0AKSMkwtYChYgWW+IsYDXq7twKWadrZ9
    6/S0uHHePlvhDHefcYCyvJB0JolJyoNNjcAyWT2mwKblWGmQdCaJZRqCTe/QKM5VNDu3rbZZnPqY
    Pxyf4gZBZ7Qb5jb5oPwWrtW1Iy5Wi+YuE+289wHthlkGRsamMDw26SsaBV6cEFrdhoCV2A1D0JlI
    ByNInBVY6KQs08EIAvR5vCU3bZtF31LOkr/U0/qHAXQwQgC8f6nWKULz+BTeu1iztPO6rMTyJeiM
    esEC9A2PLe8yDSuwDUi9YDGxAsuc7AWvxNKghABqASkhhGgBl7x9Q6EIQByMIBhKoQSJZamCo1QK
    ZCWzc6I4jl/V7loBiERqfAxS4tmp0xgGGJ+aRkOXyUcqcWFMikNJvhHGpDikJ8dBo1I69w2PTmJ4
    dAJdA2Z0DppR0dDp5UjSIqhOiFatwCpjPCfMXwEWZyc7t3uHx8JGgMakOBzeVoz8DNfiNZ4k6KKQ
    oIvCqkwDAGBq/yb84UIVLla6RtZIF5ITIhhMCYQ9GwtwaFuRr2g8tGolHjmwGRsLMvDzt8/6ih7W
    kHRGnZBFcuiOIuzeWCC4z2qbQfeghS18BliV6bLu7izl3NHfOnYYgOuC//CVP5MjBxGSzuSCoRS/
    WJuXJii+pq5BlNe2sfNDM/anAPa/29bmYkNBurMavlTVgt+fuco7xu1SnJvmK4qoWBYnZCWgUSlw
    ZPd6XvjHNxrx/qVa4qOny9WtuFTVgnt3lgBg8IfzrvmrpUxQnZCVwK4N+byZ8stuNOH9y7WEFFze
    u1BFviqSRAJPQgozk5GWEAuVItJepQG22Tl0mSyoaxP2slVKOQqMiUjWRyMuWmNvjzGwTEyjf3gM
    Fc3c2fHjYjQoLchwWrDWniG09Awh15iITYWZUCsVABikJXLn/xsZm/RbfP6gVStRujoDhVmp0Kpd
    QmcAdPQNo+xGIwYt4wCAu0pXISkuRvAaP3L3Fjadfd9rH5Rz9pfkpWNdnhG59qVnGfu/lU3dOF1e
    g/GppZlWmPwkJAwsYKJOix3FWUh0m3HUnby0BJTmG/GXKw0YNI87wwvSk7C/tAAqJb+pmwVgfX4a
    1hek4Z1z1TCPTwEA9NFazmqZDAOsyU7BpsJM3jHcKbvR5HV/IBzdvQEH7yB71UXZqbhn+1q88ufL
    +PhGA7asyUZxjnDb776d3GaCQ4C5aUn4/KGtKMlLF0qG9fkZeOCuUvzyxFlcrFx83oijYcSuP6Ui
    EjuKs5Go8742R2yUGoe3rsarp68BAO5cm4NNq4UL152U+Fgc/9RW/OrURcGV0ItyUqD3Y12Q5m5y
    f2WCLgrbinPhvAyMy9IArMjrO/tR396PRw9uwc71+cRjufPEp7Zzbjh/yU1Lwr8++WlEaVRe40Vr
    VPjWscP4T4bBhapF9lWSLaC4yUmJ54mvoqUX3aZRGBN1KMpKhkohh8kygb9caQAA5BsTOeKbnplD
    dUsvOgbMAMMgNlqNrWuyEBetAQColQrsLc3Hny/XwRNP8ZnHpwQFOeLl5aSE2Cjs82N+6Pr2flys
    bEHp6kxo1UoMWSZwvrIJHX0jYMBAq1Ji18YCFGWnOtPcVboK7X3D7AbD94JrWnvYXfYLHaVR8cR3
    5kodLlW3gAGDKLUKB+8owvr8DOf+rz64b9ECJOlM9C8lxXjcpZUtfbhyqwsMw6B7cBQtvUPYmG/E
    xzdbMD3DjlresTabk+ZkWRX6R9gRzgzDgOln0NAxiL85vMUpwg0F6bhU0wYhpm2zOHO1HtfqO8Ew
    DO7eUohdG/yzUoHSOTCC5/7nDzi4tQgny26y1pJxzeBwtb4dP/zyZ9g2H4Ata7Jx/AcvAwy7/5Xn
    nuQc74evvA8GcPbD/f39Ozni+93pcpwqu+HsLmIY4FJ1M775+UO4s4TNY7RGhcPb1uL9y9W4bUiD
    ERiw6vT8iBVjYiynLWiyTOL01QbYZucAsNZPF6V27q9u7cOAQDU1PTOHyqYeTlhOqmuZL3fe+ugm
    rte7nttaZ5ZweL4AU9MzOFVGftH92q0OznaSPoYQk8/+zWuc3wdGxvDOuZuC8V59/zJne32ByyLe
    DiSdid4JGbdyvbBEXRQe2LUWY1M2dJtGYbJMoNtkwejENAAg2W0dOADINOjx2T0lzm0GcN6NKiW3
    GyUuWgPz2BQnrG9oFK29Q5ywXhP/BSVjUhy6B4Wn5+gatODFU+fsloi1RvftLEGGgTxrfmZKPAqz
    DMg0JECrViArJQFatWtggzvJcTEwjfhebmxdnpGzHa1R4dm/vZdjcRjHvx6yyDeSn3H7Q9g6IQ1d
    JqxKT+K1A2O1KhRlJQNZ7OOtuvYBXKpph0rB9Xh1UWqORfRGSkIs2nqHOWGtHtsAMDLOb++tyzcS
    BWi1zaCxc9BZxTEMgykBhwdgu1+O7F7vtyOyGKI0KqIX7ElKgs5XFO8QdLYsVfDs3AIvLIpw97qj
    VERytset7EU6fbUBVa19zmpWiKJsAw5t9d3QXwrMY1M8K7i1KJvXMR0oWrUSTz20lyg+k2UCde19
    YbnaErEKXg4nxDI5zQvLTYlDFaGzGACU8kj7GEIXM3bB2WbncbWhG1fqu5AQGwVjQiwSdVrkpnHb
    bBnJcWju4VaX1a19aHSfu4VhOFWho3JgGAZW2yzUCn6foRDNPSakJbmsgkalwD3bi3HiY+E2lT/s
    LMlHpsE1jG1qegbnK5pxrqIRJsu401H4p0fuRlGOyxO+XVp7TPjd6XKXZXareh0lwzgKa7EQjrFs
    3TA9w+MwJrgax7kpenSZxjAybhWMvzE/lWcB2/rNvHhDo5MwWSbAMAxi6jpx7441iNWSq1hdlBqd
    A2anAF0vRQMqRSQM8TFo7xtxhmencMcxkjhf0Ywta7I4Vm9rcTYYACfP3p4IV2cZONunym7ifEWz
    6+axE6XxXZsIUd3Sg0mrzekFG+Jj0dJrwsTUNMcLhv3vjpI8XKhsdt60i4GUftlmRugZ5nqeSnkk
    9qzLQl6qHtFu1XFmsg77N+SiwMi1Zr3D4xi2OwSJOi0e2lMCY2IsJ47DEXFn0DyBUTcLnGnQY0sh
    34NTK+V4aH8pHt5firs2Bt7estpm8e65Sl74HcXZePqhvSjJ5zb4HWQk61kH5DaX7SrKTkVWirC3
    LsTaXO55fFLrmqk/SqPCc0/eK9gh/fg92/HPjx3G979wBNE+Oqz9gaQz/+qb26BneByDo5NIdusy
    UcojsbnAv+FC1+1dJAmxWhzashoqRSTu2VqI+s5BtPSyHbNsRzTXanQPWjBomcDRnWudYTtLclGQ
    kYTOfjN7JzIMSvKNUNsf0W0rzkZKfCxeO3MNgVDT0otziU28IVnG5DgcO3wHjh2+A92DZkzZZgGG
    PB7Qgee4wM/s2YhEXQxutfeBAYM12ak4vK2YkJplctqGKLVLME8/tA/ltW1gwHrBz/zqJLYV5zpF
    l2tMwo+++iAuVbcAYC3VnevyYIhnb/b1BRn49TNP4Os/ewN9Q0s/CeeyDkYob+jFzqIM6KP980Id
    XL7V6bR+ezfksYMP7BRmJqOQcCG77OJjAHx0own7Sl3CMOhjYPDSX3arw/crA0KcLq+D1TZLHBEd
    yAKFZ8pvYWeJyxpr1Uoc2lbEO/bU9AyxS+ZKXTv2lrqcsSiNCvs2Fzq3J602/OClP3GehhjiY/GZ
    PRt5x3JwsbIJ/cOLmxuHpLMIsn+yeGbn5nGhthMN3fyuDCEmrDP4U3kDGrtdjsTpa43oHfbdx1XX
    PoDT9kdxAFDT1o9T56o51bEQlgkr3jlfjYom7qiYQCi72YQf//YMqpu5Hdu+mJqewaWqFvzi7bN4
    93wlhkYn8PoHV716udfqO1B2s5G4/08XqzA57X0ES2uvCf/yq5OoavGe5wmrDSc+voFfnjjrNZ5/
    COtMduzZFwXVdvTQnZxtbt1t34bbd8a9AcsP16oVyE2Jgz5KA32MGko5a9VGxq0YGZ/C8JgVjd1D
    vOPCnj5Bp0W2QW9/CsI4/ke3aRTNvUMYm5h2/R64v12QnojkuGgY4mOcVXD/yDgs41ZUNHdzzlUX
    rRYcjiV0XPDKANDHalGSZ4QxOQ7xsVqOBeweNGNqegZdA2YMjU6gorELk9MznGODATRqBe4syUdm
    Sjy0KiUABibLBK7d6kBdey+KslOxJjvVmZezNxthGhljzwMMtCoV9m5aheJcIxzGhGHY58Lvnqvg
    /F6uMQnbi3M5w7EmrdNo7ja5hmO5593tPBnHteaFuf460hZlCfc3yo49+wIjtOPooZ2c7cUKkPEI
    52TKMz484gmk9zwuOOmFjwuhcF4ePArXy3HBS8+m46XnhDl+15Hetc39bbd07r/DCfM4FjGt/dju
    588Lc6UFPLa9nif53N3TFmUJO2XL1g0TTFbgZFNhB+n6LKsTEiwkkAXJQ9KZJN4JoRYwHBC+QtQC
    UoICtYCUEEMtICWEEC2gFC4etYDih+gFE6UZRoR/DlYABJ1RC0gJCtQCUkILtYCUUEJ+EkLYEU5I
    IQ9LjdhuSklXwWIrbDEguvKQchUshTwsNWK7KcPMAgZWfIHFXhmIrjzCywIGdlaBxV4ZiO2mJDsh
    YjpLypIhtssq6cEIlHCAVAVT/VGCALWAlBBDLSAlhJB0JonVMmW+IlBEi+gnqPSH8M+B9CHpTBJV
    sNj6vCh8JO2EhH8OVgIBWsDdz/+H8A6Zq8Ulc2zLCK2wCIEmpiOuexqP9DKhdI54XtIRz0Umg0wo
    rud3f48HuPLmWR6OMMJ5CP6G53eBtH6XiSPMASmdPZxzzsTvjm1ZQHlzlnlEBB4jTEMjCSeEEr7Q
    9YIpQYGkM5EORqBIDeJgBHEOx6JIDmoBKaGEpDPqhFBCCnVCKEGBOiGUkEKdEEpooRaQEkrITghj
    3+v5kTjynBzIc3IQEcddny7cufnEIfR86VFf0YIPQWdhNRyr/bmnUaDLQnvrdRiff523P0KvR+Qz
    z7Df33oLtmvclY8i09LQ+sQR5MVmutIAsM3boHjue654KSmQfe1rMNtGEfPv/wVPZGo1Ir/9bUzP
    26D+v9eB48dxy9yCVf/9W17cYJOsSUBGdBr465WGFuJwrDDSH9Kj2GW5snM3YU77Lhgrd+FD1ebN
    cCzo6mnZ1Pv3Y+7AAeQBqByoRunVDjBWKyL0erRuyoL7Qq/z/f0Yt41Cr9JhIS4OCxbuElWKwkIs
    ALhlbkapWu13EUYaDLA88TCm2+qR9PYZX9GlBaGQwsoCauSuJb8URUWYuX6ds39w91YIrXWpyMnB
    3IEDMNtGoX/1TRS3tsLmNnJj9Vn+6I6ki9cxt28fFIWFsH3yCWdf7d4SrAFQ+tdqzDY0IPKFF7DK
    4nsdNZlKhThlLPp9RZQgJJ1FMAzroHh+xEp7Kyu6qoPctc0i09IQr9KhZoS/jJX5+CMAAP2rb2Ku
    1bVapDdm6+oAAN13beaEy9RqrNHnw2Ibw2x9PSLi4mDdvBaKQtd6bGNHD0BZUgJ5Vhaanvo8xo7s
    hzwrCxWf2gIAsKUZYXrwbpgevBsAIM/MRNcjBxGh465Krly7Fk2PHXT9tkoFZWkpur9yDN1fOYaW
    L30Oken+rXgeakg6C5snITKNBgCQ3zSE5tEOrItf7QwDgM4juwEAxW9+BACoKWSXnopMS4NepUPv
    5KDf4gPYathsG0WqNplTnTuEpqyuAgBE6HTQbt6Jlv0uoepLdmD48F5YH3sYhXF5GM3JxMiGfKxP
    XAMAyIoxImX1VqSs3goAaNtRiOzczbxmQ9uejSjMKHVuK4qLMXfggHM7MzoNzKOPQp4f+HKzYiFs
    quBIo2upp9UfV2D+SBZUmzdj+vx5AIAhsxg9kwNIbmuDAoBCx1bGitxczAPIvFwF78sW8hGqhh3V
    r+ZaDea9pI1TxaJ/yoTkX7yEDBu7eKCsohnM44+jv+GKqw1IGvAqwGxtLdDcjPQxdvHGyIwMMI8+
    ioa9G5DX3OwjdWghVsHh2A0zU1MDAGjYsx4Aaxk0cjUyPyznxZWpA1sq1p3ZW7cAANXbVwFwVb9m
    2xjm+3235Ay/+T0Ym/eVKwOBsdnAjI1BplIhMiMDEbHsmr6Z0f6twRxSCDoLGwvozoLZjP7JAeTr
    sjCn0aB99zpkA5ipreXFne/rAwBUlGah8EPebq+w3vAYivT5mFepnN5v4kcX4Y+sPL3nxSJTqdB8
    /H4U6HLAAE4LrIpUiq7bxZOwd0Ii09i7fK63FwCc1k5RXAxDZjGqRxqxYDY74+tVOk78vNhMTpvR
    X5Iusn2J8pwc1O4tAQDM1td7S7JsmL74GAp0OagYqATz4otY+NGPfCURDWHvhETYxcNMsy25mepq
    AMDUZ49AI1dj/Zmbzrg9kwOItwtwwWxGy1gnNHIVqr90FIEy194OAKi9ZyvW6PPRN2XiCP12GEgU
    XrndUaU60Klc2xFJSUjWJKJzohclr5wGM7q4FczFQoT7OrnuH7GzYDajZ3IAGrka1rlpTvU7Pc+t
    ILOffw3WORs2GErQ8cyXndYUYDus5Tk5IDHX3o7peRuK9KynafzLeWJcXyzYnYesGCOnbZpXw1rp
    3v3bIFOrIVOpUPuFo9Ap+UJ1D6t64hBvv1gh6UzuK6GYyfywHPP334+BzloYrVaiR7lgsUD9/Ivo
    /btH2MdwTz3Fz/h3viOUFABQZ25GaWIxgMVVvwsWC8ZnxhCnjAW+8Q10jPcg/eevYKamBkMHdsCg
    TQS+/nUAwKp5GzrHe5AZw3r/CyYTuid6kRmdhtF//DIAYIMyBrZ5G1SRKuJvip3IrE37viu046EZ
    k1Aw5yLLHNukrgTS+6Oe+0jvk7oRER8PeW8v2xUxxz5wWxgbg9JqRfSFa2DGx53nkjy1gMjeXle/
    n0wGZmICUec+QWRfH+QmE5oT5ei0dCL9k2owly5hYWiIf77246V1DGPBNgn5tRuY7+527bP/tcrn
    kFLZjIWBAQDAaLwS0wNdUDW08Y6nqW3AgA7okduwqqwS84ODAIComzXoSFFiVM6gf7AZhtfeg75z
    APVxs0jqHAJmZqCraoBiYgL9qTr0jfXA8Lt3oRocwjW9DamVLQCABOsCrsdNI8W+7eva+PdesBu3
    816wTIbXhmb5aQDIdn3xB4L17YmJOqHgwARIX0znIhTuz3kggDJxhDlYkhfT3Qggb+4vpt/bwH1u
    7yCsBiNQwhiCzsKyH5ASfpCfhFAoIYS+FUcJCvStOEpIIemMOBjhqMY1vo1CWTQEnVEnhBIUJPFO
    CCWMIegsggH5v/vVq4RTUSgBcKh2nKgx8oBU++d+FRUh5fY5VDfpVV8RPvQHBsB9VISU2+Bg3aRP
    bUWUv/RdGWmojPvnXmUB+ZcoFA8O1k361FTAw7GWVIQM4TsA0Y8vDytIhRn6Qr7y8r+5hi9sOf6c
    pwwolGXl6svf446f2fIEFSElOFx95XsywG04mIPNVISUZeaaXXyAgAABYNPjz1IRUpaF669+n6O5
    /wcZqViyoNwg7gAAAABJRU5ErkJggg==
    "
                    preserveAspectRatio="none"
                />
            </g>
        </svg>
    );
};

export default McIcon;
